import { Box } from 'src/components'
import styled from 'styled-components'

export const ContentTypografy = styled(Box)`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    min-height: 20%;
    line-height: 22px;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
    align-items: center;
`

export const Container = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    font-family: inherit;
    overflow: hidden;
    margin-top: 10px;
    align-items: center;
    border-radius: 1rem;
    flex-direction: column;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.white};
`
export const SubContentTypografy = styled(Box)``
export const Image = styled.img`
    width: 49.97px;
    height: 49.69px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 71px;
        height: 71px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 63px;
        height: 63px;
    }
`
export const ContentButton = styled.a`
    margin-top: 6px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 60%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        margin-top: 15px;
    }
`
export const TittleTypografy = styled(Box)`
    margin-bottom: 10px;
`
export const Button = styled.button`
    min-width: 102px;
    height: 35px;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 29px;
    display: flex;
    margin: 0 10px;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        min-width: 127px;
        height: 44px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 86px;
        height: 44px;
    }
`

export const ButtonSupport = styled.a`
    min-width: 102px;
    height: 35px;
    background: #1ad741;
    border-radius: 29px;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    display: flex;
    margin: 0 10px;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.white};
    :hover {
        color: ${({ theme }) => theme.colors.white};
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        min-width: 127px;
        height: 44px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 86px;
        height: 44px;
    }
`
